<template>
  <div>
    <Navbar style="z-index: 999;"/>
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Agenda</h1>
          <div v-if="searchAtt" style="margin-top: -11.5px">
            <vs-col vs-w="9" vs-sm="6">
              <vs-input
                v-model="attendanceId"
                label="Código do Atendimento: *"
                type="number"
              />
            </vs-col>
            <vs-col vs-w="3" vs-sm="6">
              <vs-button
                style="width: 100%; margin-top: 15px"
                icon="search"
                :disabled="!attendanceId"
                @click="attendanceSearch(attendanceId)"
              >
                Buscar Atendimento
              </vs-button>
            </vs-col>
            <div
              v-show="msgAttendance"
              style="width: 100% !important"
              vs-justify="center"
            >
              <vs-col>
                <vs-alert
                  color="#1F74FF"
                  closable
                  :active.sync="msgAttendance"
                  close-icon="close"
                >
                  {{ sanitizedMsgAttendance }}
                </vs-alert>
              </vs-col>
            </div>
            <vs-divider />
          </div>
          <p style="font-size: 0.7em">
            * Clique no número do atendimento para visualizar e/ou atualizar a
            discussão e os parâmetros do atendimento.<br />
            ** Clique no nome do cliente para visualizar os dados de contato
          </p>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <div class="table-search-wrapper" v-if="diary && diary.length > 0">
          <div class="search-input-group">
            <vs-input
              type="text"
              v-model="searchTerm"
              placeholder="Pesquisar..."
              @keyup.enter="performSearch"
            />
            <vs-button
              icon="search"
              type="flat" @click="performSearch"
            />
          </div>
          <template v-if="diary && diary.length > 0">
            <vs-table
              class="pd-table"
              :max-items="pageSize"
              :data="diary"
              description
              :description-items="descriptionItems"
              description-title="Registros"
              description-connector="de"
              description-body="Mostrar"
            >
              <template slot="thead">
                <th>Simular</th>
                <th @click="sortData('CODATENDIMENTO')">Atendimento</th>
                <th @click="sortData('ABERTURA')">Criação</th>
                <th @click="sortData('REPASSE')">Repasse</th>
                <th @click="sortData('CLIENTE')">Cliente</th>
                <th @click="sortData('TAREFA')">Etapa/Fila</th>
                <th>Tabulação</th>
                <th>IA</th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" class="pointer" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                      <vs-button @click="startSimulation(data[indextr])" color="primary" type="filled" icon="arrow_forward" />
                    </vs-td>
                    <vs-td>
                      <div class="b__important">
                        <a href="#" @click="showDiscussionScreen(data[indextr])">
                          {{ data[indextr].CODATENDIMENTO }}
                        </a>
                      </div>
                      <div class="b__small b__bt">
                        {{ data[indextr].TIPOATENDIMENTO }}
                      </div>
                    </vs-td>
                    <vs-td>
                      <div class="b__important">
                        {{ data[indextr].ABERTURA | moment }}
                      </div>
                    </vs-td>
                    <vs-td>
                      <div class="b__important">
                        {{ data[indextr].DATAULTIMOREPASSE }}
                      </div>
                    </vs-td>
                    <vs-td>
                      <div class="b__important">
                        <a href="#" @click="showContact(data[indextr])">
                          {{ data[indextr].CLIENTE }}</a>
                      </div>
                    </vs-td>
                    <vs-td>
                      <div class="b__important">{{ data[indextr].TAREFA }}</div>
                      <div class="b__small">{{ data[indextr].ATENDENTE }}</div>
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].TABULACAO }}
                    </vs-td>
                    <vs-td>
                      <vs-button
                        v-if="data[indextr].CLASSIFICADOIA === 'S' && data[indextr].SENTIMENTOIA === 'positivo'"
                        @click="showAiDetails(data[indextr])"
                        color="warning"
                        type="flat"
                        icon="star"
                      />
                    </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div style="display: flex; justify-content: center; align-items: center; margin-top: 1.5rem;">
              <vs-button @click="previousPage" :disabled="page <= 1" icon="arrow_back">
                <p class="pagButton">Anterior</p>
              </vs-button>
              <span style="margin-left: 25px; margin-right: 25px; font-size: 1.1em;">
                Página {{ page }}
              </span>
              <vs-button @click="nextPage" :disabled="!hasMorePages" icon-after icon="arrow_forward">
                <p class="pagButton">Próxima</p>
              </vs-button>
            </div>
          </template>
        </div>

        <vs-alert color="danger" icon="new_releases" v-else>
          <b>Sem resultados para serem mostrados</b>
        </vs-alert>
        <vs-popup
          :title="
            this.selectedMailing != null
              ? 'Atendimento - ' + this.selectedMailing.CODATENDIMENTO
              : 'Atendimento'
          "
          :active.sync="discussionScreen"
        >
          <vs-card>
            <vs-tabs alignment="center">
              <vs-tab icon="group" label="Histórico">
                <p v-html="history"></p>
              </vs-tab>
              <vs-tab
                icon="edit"
                :label="
                  history == 'Atendimento sem discussão'
                    ? 'Adicionar Discussão'
                    : 'Atualizar Discussão'
                "
              >
                <vs-row>
                  <vs-col>
                    <vs-textarea
                      v-model="discussionText"
                      height="10rem"
                      :label="
                        'Informe o texto para ' +
                        (history == 'Atendimento sem discussão'
                          ? 'adicionar'
                          : 'atualizar') +
                        ' a discussão do atendimento'
                      "
                    />
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-button
                    icon="check_circle"
                    color="#139B0E"
                    style="width: 100%"
                    :disabled="!discussionText"
                    @click="updateDiscussion()"
                  >
                    {{
                      history == "Atendimento sem discussão"
                        ? "Salvar"
                        : "Salvar Discussão"
                    }}
                  </vs-button>
                </vs-row>
              </vs-tab>
              <vs-tab icon="assessment" label="Tabulação">
                <div>
                  <div style="display: flex">
                    <span
                      style="
                        font-size: 16.5px;
                        color: #9b0e1c;
                        margin-right: 3.5px;
                      "
                      class="material-icons"
                    >
                      block
                    </span>
                    <h4>Motivo/ Ação</h4>
                  </div>
                  <div style="display: flex">
                    <vs-select
                      style="margin-top: 8.5px"
                      name="motivonaorealizacao"
                      autocomplete
                      width="100%"
                      v-model="failureToRegister"
                      placeholder="Selecione um Motivo/ Ação"
                    >
                      <vs-select-item
                        :key="index"
                        :value="option"
                        :text="option.DESCRICAO"
                        v-for="(option, index) in notEnrolling"
                      />
                    </vs-select>
                    </div>
                </div>
                <vs-divider />

                <div>
                  <div style="display: flex">
                    <span
                      style="
                        font-size: 16.5px;
                        color: #9b0e1c;
                        margin-right: 3.5px;
                      "
                      class="material-icons"
                    >
                      bookmark
                    </span>
                    <h4>Curso</h4>
                  </div>
                  <div style="display: flex">
                    <vs-select
                      style="margin-top: 8.5px"
                      name="curso"
                      autocomplete
                      width="100%"
                      v-model="courseEdit"
                      placeholder="Selecione um Curso"
                    >
                      <vs-select-item
                        :key="index"
                        :value="option"
                        :text="option.DESCRICAO"
                        v-for="(option, index) in courseAttend"
                      />
                    </vs-select>
                    </div>
                  <vs-divider v-if="!(courseEdit && courseEdit.DESCRICAO == 'OUTROS')" />
                  <div
                    v-if="
                      courseEdit &&
                      courseEdit.DESCRICAO == 'OUTROS'
                    "
                    style="display: flex; margin-top: 10px;"
                  >
                    <p style="font-size: 0.915em; width: 35%">
                      Digite o curso desejado:
                    </p>
                    <vs-input v-model="otherCourse" />
                  </div>
                </div>

                <vs-divider />

                <vs-row style="margin-top: 20px;">
                  <vs-button
                    icon="save"
                    color="#139B0E"
                    type="filled"
                    style="width: 100%; font-size: 1.1em; padding: 10px;"
                    @click="saveAllTabulationData()"
                  >
                    Salvar Tabulação
                  </vs-button>
                </vs-row>
              </vs-tab>
              <vs-tab icon="account_circle" label="Lead">
                <div>
                  <div style="display: flex">
                    <div style="width: 38.5%; margin-left: 5px">
                      <div style="display: flex">
                        <span
                          style="
                            font-size: 16.5px;
                            color: #9b0e1c;
                            margin-right: 3.5px;
                          "
                          class="material-icons"
                        >
                          flag
                        </span>
                        <h4>Estado</h4>
                      </div>
                      <div v-if="!editProspect">
                        <vs-input
                          style="margin-top: 8.5px"
                          disabled
                          :placeholder="
                            this.selectedMailing != null
                              ? this.selectedMailing.ESTADO
                              : '-'
                          "
                        />
                      </div>
                      <div v-else>
                        <vs-select
                          style="margin-top: 8.5px"
                          name="estadoprospect"
                          autocomplete
                          width="100%"
                          v-model="stateProspect"
                          v-on:input="changeProvinces($event)"
                          placeholder="Selecione um Estado"
                        >
                          <vs-select-item
                            v-for="(option, i) in states"
                            :key="i"
                            :value="option.CODIGO"
                            :text="option.CODIGO"
                          />
                        </vs-select>
                      </div>
                    </div>
                    <div style="width: 51.5%">
                      <div style="display: flex">
                        <span
                          style="
                            font-size: 16.5px;
                            color: #9b0e1c;
                            margin-right: 3.5px;
                          "
                          class="material-icons"
                        >
                          location_city
                        </span>
                        <h4>Cidade</h4>
                      </div>
                      <div v-if="!editProspect">
                        <vs-input
                          style="margin-top: 8.5px"
                          disabled
                          :placeholder="
                            this.selectedMailing != null
                              ? this.selectedMailing.CIDADE
                              : '-'
                          "
                        />
                      </div>
                      <div v-else>
                        <vs-select
                          style="margin-top: 8.5px"
                          name="cidadeprospect"
                          autocomplete
                          width="100%"
                          :disabled="!stateProspect"
                          v-model="cityProspect"
                          placeholder="Selecione uma Cidade"
                        >
                          <vs-select-item
                            v-for="(municipio, i) in cities"
                            :key="i"
                            :value="municipio"
                            :text="municipio.title"
                          />
                        </vs-select>
                      </div>
                    </div>
                    <div style="width: 10%" v-if="!editProspect">
                      <vs-button
                        style="margin: 17.5px 0 0 5px"
                        icon="edit"
                        type="filled"
                        color="danger"
                        @click="
                          editProspect = true;
                          cityProspect = null;
                          stateProspect = null;
                        "
                      />
                    </div>
                    <div style="width: 17.5%" v-else>
                      <vs-button
                        style="margin: 18.5px 0 0 5px"
                        icon="close"
                        type="filled"
                        @click="
                          editProspect = false;
                          cityProspect = null;
                          stateProspect = null;
                        "
                      />
                      <vs-button
                        style="margin: 18.5px 0 0 5px"
                        icon="done"
                        :disabled="
                          !cityProspect ||
                          (cityProspect.title == this.selectedMailing.CIDADE &&
                            stateProspect == this.selectedMailing.ESTADO)
                        "
                        type="filled"
                        color="#139B0E"
                        @click="
                          modifyProspect(
                            selectedMailing,
                            cityProspect,
                            stateProspect
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </vs-card>
        </vs-popup>
        <vs-popup
          title="Detalhes da Análise de IA"
          :active.sync="aiDetailsModalActive"
        >
          <div v-if="selectedAiData" style="padding: 10px;">
            <p><strong>Objeção:</strong> {{ selectedAiData.OBJECAOIA || 'Não informado' }}</p>
            <vs-divider/>

            <p><strong>Sentimento:</strong> {{ selectedAiData.SENTIMENTOIA || 'Não informado' }}</p>
            <vs-divider/>

            <p><strong>Emoção:</strong> {{ selectedAiData.EMOCAOIA || 'Não informado' }}</p>
            <vs-divider/>

            <p>
              <strong>Link da Conversa:</strong>
              <a :href="selectedAiData.LINKCONVERSAIA" target="_blank" v-if="selectedAiData.LINKCONVERSAIA">
                Acessar conversa
              </a>
              <span v-else>Nenhum link disponível</span>
            </p>
          </div>
        </vs-popup>
      </section>
    </div>
  </div>
</template>

<script>
import sortBy from "sort-by";
import Mailing from "../services/mailing";
import moment from "moment";
import {
  updateStepsInformation,
  onlyUpdateDiscussion,
  getLoginDataFromStorage,
} from "../helpers";
export default {
  name: "MyDiary",
  data: () => ({
    searchTerm: "",
    descriptionItems: [10, 50, 100],
    diary: [],
    selectedMailing: null,
    discussionScreen: false,
    aiDetailsModalActive: false,
    selectedAiData: null,
    error: null,
    attendanceId: null,
    discussionText: null,
    editProspect: false,
    cityProspect: null,
    stateProspect: null,
    cities: [],
    states: [],
    notContact: [],
    notEnrolling: [],
    courseAttend: [],
    editSpeaker: false,
    msgAttendance: false,
    lackOfContact: null,
    otherCourse: null,
    failureToRegister: null,
    speakerNew: null,
    courseEdit: null,
    history: null,
    contactScreen: false,
    searchAtt: false,
    client: null,
    telephone: null,
    email: null,
    city: null,
    course: null,
    sortProperty: "CODATENDIMENTO", // Propriedade inicial para ordenação
    sortOrder: "asc", // Ordem inicial da ordenação
    page: 1, // Página inicial
    pageSize: 10, // Quantidade de itens por página
    hasMorePages: true,
  }),
  computed: {
    sanitizedMsgAttendance() {
      if (!this.msgAttendance) return '';
      return this.msgAttendance.replace(/Telefone\s+[\d\s()-]+/gi, '');
    }
  },
  created() {
    this.userData = getLoginDataFromStorage();

    const profileSpecial = this.userData.profiles.find(
      (element) =>
        element == "CoordenadorVend" ||
        element == "SupervisorVenda" ||
        element == "DBA"
    );

    if (profileSpecial) {
      this.searchAtt = true;
    } else {
      this.searchAtt = false;
    }
  },
  mounted() {
    this.init();
    this.getStates();
  },
  /*watch: {
    searchTerm(newValue) {
      const valueAsString = String(newValue || '');
      if (valueAsString.length >= 7) {
        this.performSearch();
      }
    }
  },*/
  methods: {

    performSearch() {
      this.page = 1;
      this.findAttendance();
    },

    attendanceSearch(attendance) {
      this.msgAttendance = false;

      this.$vs.loading();
      new Mailing()
        .searchAttendance(attendance)
        .then((res) => {
          this.msgAttendance =
            res.data == "" ? "Atendimento não encontrado" : res.data.MSG;
        })
        .catch((error) => {
          this.msgAttendance = error.response.data.error;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    sortData(property) {
      if (this.sortProperty === property) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortProperty = property;
        this.sortOrder = "asc";
      }
      this.diary.sort(
        sortBy(this.sortOrder === "asc" ? property : `-${property}`)
      );
    },

    init() {
      this.findBy();
    },

    getStates() {
      new Mailing()
        .getStates()
        .then((res) => {
          this.states = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeProvinces(state) {
      this.$vs.loading();
      this.cityProspect = null;
      new Mailing()
        .getCities(state)
        .then((res) => {
          let cidades = res.data.map((municipio) => ({
            value: JSON.parse(municipio.value),
            title: municipio.title,
          }));
          this.cities = cidades;
        })
        .catch((error) => {
          console.error("Error trying to fetch cities", error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    showContact(tr) {
      this.contactScreen = true;

      this.client = tr.CLIENTE;
      this.telephone = tr.TELEFONE;
      this.email = tr.EMAIL;
      this.city = tr.CIDADE;
      this.course = tr.CURSO;
    },

    modifyLackOfContact(infoAttendance, param7) {
      this.$vs.loading();

      this.editLackOfContact = false;

      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,
        PARAMETRO_7: param7.CODIGO,
        PARAMETRO_8: "",
        PARAMETRO_177: "",
        PARAMETRO_189: "",
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Motivo da Falta de Contato editado com sucesso.",
            color: "success",
            position: "top-center",
          });

          onlyUpdateDiscussion(
            "Alterou o Motivo da Falta de Contato com o Cliente \n" +
              "DE: " +
              infoAttendance.MOTIVONAOCONTATO +
              "\n" +
              "PARA: " +
              param7.DESCRICAO,
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );

          infoAttendance.MOTIVONAOCONTATO = param7.DESCRICAO;

          this.getDiscussion(
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    speaker() {
      this.$vs.loading();

      this.editSpeaker = true;
      this.speakerNew = null;

      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },

    modifySpeaker(infoAttendance, param225) {
      this.$vs.loading();

      this.editSpeaker = false;
      this.speakerNew = null;

      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,
        PARAMETRO_225: param225,
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Palestrante editado com sucesso.",
            color: "success",
            position: "top-center",
          });

          onlyUpdateDiscussion(
            "Alterou o Palestrante \n" +
              "DE: " +
              infoAttendance.EXTERNO +
              "\n" +
              "PARA: " +
              param225,
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );

          infoAttendance.EXTERNO = param225;
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    modifyFailureToRegister(infoAttendance, param8) {
      this.$vs.loading();

      this.editFailureToRegister = false;

      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,
        PARAMETRO_7: "",
        PARAMETRO_8: param8.CODIGO,
        PARAMETRO_177: "",
        PARAMETRO_189: "",
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Motivo/ Ação editado com sucesso.",
            color: "success",
            position: "top-center",
          });

          onlyUpdateDiscussion(
            "Alterou o Motivo/ Ação \n" +
              "DE: " +
              infoAttendance.MOTIVONAOINTERESSE +
              "\n" +
              "PARA: " +
              param8.DESCRICAO,
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );

          infoAttendance.MOTIVONAOINTERESSE = param8.DESCRICAO;
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    modifyCourse(infoAttendance, course, other) {
      this.$vs.loading();

      this.editCourse = false;

      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,
        PARAMETRO_7: "",
        PARAMETRO_8: "",
        PARAMETRO_177: other ? other : course.DESCRICAO,
        PARAMETRO_189: other ? "51" : course.CODIGO,
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Curso editado com sucesso.",
            color: "success",
            position: "top-center",
          });

          if (infoAttendance.CURSOCONVERSAO == "OUTROS" && other) {
            onlyUpdateDiscussion(
              "Alterou o Curso do Atendimento \n" +
                "DE: " +
                infoAttendance.CURSO +
                "\n" +
                "PARA: " +
                (other ? other : course.DESCRICAO),
              infoAttendance.CODCOLIGADA,
              infoAttendance.CODLOCAL,
              infoAttendance.CODATENDIMENTO
            );
          } else {
            onlyUpdateDiscussion(
              "Alterou o Curso do Atendimento \n" +
                "DE: " +
                infoAttendance.CURSO +
                "\n" +
                "PARA: " +
                (other ? other : course.DESCRICAO) +
                "\n\n" +
                "Alterou o Curso de Conversão do Atendimento \n" +
                "DE: " +
                "(" +
                infoAttendance.CODCURSOCONVERSAO +
                ") " +
                infoAttendance.CURSOCONVERSAO +
                "\n" +
                "PARA: " +
                (other
                  ? "(51) OUTROS"
                  : "(" + course.CODIGO + ") " + course.DESCRICAO),
              infoAttendance.CODCOLIGADA,
              infoAttendance.CODLOCAL,
              infoAttendance.CODATENDIMENTO
            );
          }

          infoAttendance.CURSOCONVERSAO = other ? "OUTROS" : course.DESCRICAO;
          infoAttendance.CURSO = other ? other : course.DESCRICAO;
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    modifyProspect(infoAttendance, prospectCity, prospectState) {
      this.$vs.loading();

      this.editProspect = false;
      this.cityProspect = null;
      this.stateProspect = null;

      const payload = {
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODPROSPECT: infoAttendance.CODPROSPECT,
        NOME: infoAttendance.CLIENTE,
        CODORIGEM: infoAttendance.CODORIGEM ? infoAttendance.CODORIGEM : "",
        ESTADO: prospectState,
        CIDADE: prospectCity.value.CODIGO,
      };

      new Mailing()
        .updateProspectAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Localidade do Prospect editada com sucesso.",
            color: "success",
            position: "top-center",
          });

          onlyUpdateDiscussion(
            "Alterou a Localidade do Prospect \n" +
              "DE: " +
              (infoAttendance.CIDADE != "-"
                ? infoAttendance.CIDADE + " - " + infoAttendance.ESTADO
                : "-") +
              "\n" +
              "PARA: " +
              prospectCity.title +
              " - " +
              prospectState,
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );

          infoAttendance.CIDADE = prospectCity.title;
          infoAttendance.ESTADO = prospectState;
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getDiscussion(CODCOLIGADA, CODLOCAL, CODATENDIMENTO) {
      new Mailing()
        .getDiscussion(CODCOLIGADA, CODLOCAL, CODATENDIMENTO)
        .then(({ data }) => {
          this.history =
            data.TEXTODISCUSSAO == null
              ? "Atendimento Sem Discussão"
              : data.TEXTODISCUSSAO.replaceAll("\n", "<br />");
          this.$vs.loading.close();
        });
    },

    async showDiscussionScreen(data) {
      this.editProspect = false;
      this.selectedMailing = data;
      this.$vs.loading();
      this.loadDropdownData();
      this.getDiscussion(data.CODCOLIGADA, data.CODLOCAL, data.CODATENDIMENTO);
      this.discussionScreen = true;
      this.discussionText = null;
    },

    showAiDetails(atendimentoData) {
      this.selectedAiData = atendimentoData;
      this.aiDetailsModalActive = true;
    },

    saveAllTabulationData() {
      this.$vs.loading();

      const infoAttendance = this.selectedMailing;
      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,

        PARAMETRO_7: this.lackOfContact ? this.lackOfContact.CODIGO : "",

        PARAMETRO_8: this.failureToRegister ? this.failureToRegister.CODIGO : "",

        PARAMETRO_177: this.courseEdit
          ? (this.courseEdit.DESCRICAO === 'OUTROS' ? this.otherCourse : this.courseEdit.DESCRICAO)
          : "",
        PARAMETRO_189: this.courseEdit
          ? (this.courseEdit.DESCRICAO === 'OUTROS' ? "51" : this.courseEdit.CODIGO)
          : "",
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Dados de tabulação salvos com sucesso.",
            color: "success",
            position: "top-center",
          });

          if (this.lackOfContact) {
            infoAttendance.MOTIVONAOCONTATO = this.lackOfContact.DESCRICAO;
          }
          if (this.failureToRegister) {
            infoAttendance.MOTIVONAOINTERESSE = this.failureToRegister.DESCRICAO;
          }
          if (this.courseEdit) {
            infoAttendance.CURSOCONVERSAO = this.courseEdit.DESCRICAO;
            infoAttendance.CURSO = this.courseEdit.DESCRICAO === 'OUTROS' ? this.otherCourse : this.courseEdit.DESCRICAO;
          }

          this.getDiscussion(
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
            this.$vs.notify({
                title: "Erro",
                text: "Não foi possível salvar os dados.",
                color: "danger",
                position: "top-center",
              });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    loadDropdownData() {
      new Mailing()
        .reasonNotContact()
        .then((res) => {
          this.notContact = res.data;
          if (this.selectedMailing && this.selectedMailing.MOTIVONAOCONTATO) {
            this.lackOfContact = this.notContact.find(
              (item) => item.DESCRICAO === this.selectedMailing.MOTIVONAOCONTATO
            ) || null;
          }
        })
        .catch((error) => {
          console.log(error);
        });

      new Mailing()
        .reasonNotEnrolling()
        .then((res) => {
          const sortedData = res.data.sort((a, b) => {
            return a.DESCRICAO.localeCompare(b.DESCRICAO);
          });
          this.notEnrolling = sortedData;
          if (this.selectedMailing && this.selectedMailing.MOTIVONAOINTERESSE) {
            this.failureToRegister = this.notEnrolling.find(
              (item) => item.DESCRICAO === this.selectedMailing.MOTIVONAOINTERESSE
            ) || null;
          }
        })
        .catch((error) => {
          console.log(error);
        });

      new Mailing()
        .courseAttendance()
        .then((res) => {
          this.courseAttend = res.data;
          if (this.selectedMailing && this.selectedMailing.CURSOCONVERSAO) {
            this.courseEdit = this.courseAttend.find(
              (item) => item.DESCRICAO === this.selectedMailing.CURSOCONVERSAO
            ) || null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async updateDiscussion() {
      this.$vs.loading();
      await onlyUpdateDiscussion(
        this.discussionText,
        this.selectedMailing.CODCOLIGADA,
        this.selectedMailing.CODLOCAL,
        this.selectedMailing.CODATENDIMENTO
      )
      .then(() => {
        this.$vs.notify({
          title: "Sucesso",
          text: "Discussão atualizada com sucesso.",
          color: "success",
          position: "top-center",
        });
        this.discussionText = null;

        this.getDiscussion(
          this.selectedMailing.CODCOLIGADA,
          this.selectedMailing.CODLOCAL,
          this.selectedMailing.CODATENDIMENTO
        );
      })
      .catch((error) => {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possível atualizar a discussão.",
          color: "danger",
          position: "top-center",
        })
        console.error("Erro ao atualizar discussão:", error);
      })
      .finally(() => {
        this.$vs.loading.close();
      });

      const payload = {
        CODLOCAL: this.selectedMailing.CODLOCAL,
        CODCOLIGADA: this.selectedMailing.CODCOLIGADA,
        CODATENDIMENTO: this.selectedMailing.CODATENDIMENTO,
        CODCOLIGADARESP: this.selectedMailing.CODCOLIGADARESP,
        CODATENDENTERESP: this.selectedMailing.CODATENDENTERESP,
      };

      new Mailing()
        .updateParamsDiscussion(payload)
        .then((data) => {
          console.log(data);
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    findBy() {
      this.$vs.loading({ color: "danger" });

      const payload = {
        valorIni: (this.page - 1) * this.pageSize,
        valorPagina: this.pageSize,
      };

      if (this.searchTerm) {
        payload.filtro = this.searchTerm;
      }

      new Mailing()
        .getMyMailings(payload)
        .then((response) => {
          const results = Array.isArray(response.data) ? response.data : [response.data];

          this.diary = results.map((a) => {
            a.MORE = false;
            return a;
          });

          this.hasMorePages = results.length === this.pageSize;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
            this.$vs.notify({
              title: 'Erro ao buscar dados',
              text: this.error,
              color: 'danger',
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    findAttendance() {
      this.$vs.loading({ color: "danger" });

      const payload = {
        attendance: this.searchTerm
      }

      new Mailing()
        .getMyAttendance(payload)
        .then((response) => {

          if (response && response.data) {
            const results = Array.isArray(response.data) ? response.data : [response.data];
            this.diary = results.map((a) => {
              a.MORE = false;
              return a;
            });
          } else {
              this.$vs.notify({
              title: 'Atendimento não localizado',
              text: this.error,
              color: 'danger',
              position: 'bottom-center'
            });
          }
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
            this.$vs.notify({
              title: 'Erro ao buscar dados',
              text: this.error,
              color: 'danger',
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    nextPage() {
      if (this.hasMorePages) {
        this.page++;
        this.findBy();
      }
    },

    previousPage() {
      if (this.page > 1) {
        this.page--;
        this.findBy();
      }
    },

    startSimulation(mailingData) {
      updateStepsInformation({
        codAtendimento: mailingData.CODATENDIMENTO,
        codColigada: mailingData.CODCOLIGADA,
        codLocal: mailingData.CODLOCAL,
      });
      onlyUpdateDiscussion(
        "Simulação de Matrícula Iniciada",
        mailingData.CODCOLIGADA,
        mailingData.CODLOCAL,
        mailingData.CODATENDIMENTO
      );
      this.$router.push("/courses");
    },
  },
  filters: {
    moment: function (date) {
      moment.locale("pt-br");
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style>

body .vs-noti-success .con-text-noti h3,
body .vs-noti-success .con-text-noti p {
  color: white !important;
}

.vs-notifications {
  z-index: 40000 !important;
}

.vs-input--input:disabled,
.vs-input--input:disabled + .vs-input--placeholder {
  opacity: 1;
  cursor: default;
  color: black;
  pointer-events: none;
}
.vs-table-text {
  padding: 10px;
  border-bottom: 1px solid var(--secundary);
}
a {
  color: var(--dark);
}

.table-search-wrapper {
  position: relative;
  padding-top: 30px;
}

.search-input-group {
  position: absolute;
  top: -25px;
  right: 15px;
  z-index: 10;
  width: 250px;
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
}

.search-input-group .vs-inputx {
  border: none !important;
  flex-grow: 1;
  box-shadow: none !important;
}
.search-input-group .vs-inputx input {
    width: 100%;
}

.search-input-group .vs-button-flat {
  border-left: 1px solid #dcdcdc;
  border-radius: 0;
}

.search-input-group:focus-within {
  box-shadow: none !important;
}

.custom-table-search .vs-inputx {
  background-color: white;
  border: 1px solid #f0f0f0;
  border-radius: 20px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.pagButton {
  color: #f0f0f0;
  font-size: small;
}

@media (max-width: 800px) {

  .pagButton {
    display: none;
  }

}

</style>
